<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>仓库名称：</p>
        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入公司全称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>所在区域：</p>
        <el-cascader v-model="areaIpt" :options="regionList" style="width:150px" :props="{
                        expandTrigger: 'hover',
                        value: 'id',
                        label: 'cityName',
                        children: 'children',
                        multiple: false,
                      }" size="mini" collapse-tags filterable clearable placeholder="请选择所在区域" ref="areaCascader"
        />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>车位类型：</p>
        <el-select v-model="typeIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="storehouseName" label="仓库全称" align="center"/>
          <el-table-column label="车位类型" align="center">
            <div slot-scope="scope">{{getLocationType(scope.row.locationType)}}</div>
          </el-table-column>
          <el-table-column label="免费停放" align="center">
            <div slot-scope="scope">{{scope.row.freeNumber}}{{getFreeNumber(scope.row.freeType)}}</div>
          </el-table-column>
          <el-table-column prop="payMoney" label="超时收费" width="199" align="center">
            <div slot-scope="scope">1{{getFreeNumber(scope.row.payType)}}{{scope.row.payMoney}}元</div>
          </el-table-column>
          <el-table-column prop="regionName" label="所在区域" align="center"/>
          <el-table-column prop="address" label="详细地址" align="center"/>
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.status)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.status" size="mini" type="danger" @click="disableClick(scope.row.id)">禁用</el-button>
                <el-button v-else size="mini" type="primary" @click="enableClick(scope.row.id)">启用</el-button>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="primary" @click="changeClick(scope.row)" class="yellow-bg">修改</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情仓库" :visible.sync="detailDialogVisible" width='550px' center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p :style="getStyle(detailData.status)">{{getState(detailData.status)}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">仓库名称：</span>
              <span>{{detailData.storehouseName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">所在区域：</span>
              <span>{{detailData.regionName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">详细地址：</span>
              <span>{{detailData.address}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">车位类型：</span>
              <span>{{getLocationType(detailData.locationType)}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">免费停放{{detailData.freeNumber}}{{getFreeNumber(detailData.freeType)}}，超时{{detailData.payMoney}}元1{{getFreeNumber(detailData.payType)}}收费</span>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <transition name="el-fade-in-linear">
      <popup :title="dialogTitle" :show.sync="dialogVisible" width='550' center @close="dialogClose" :close-on-click-modal="false" top="10vh">
        <div class="company">
          <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
            <div-border label="基础信息" is-need="true">
              <el-form-item label="仓库名称：" prop="warehouse" style="margin-top: 10px;">
                <el-input
                  :style="'width:100%'"
                  v-model="companyData.warehouse"
                  placeholder="请输入仓库名称"
                  autocomplete="off"
                  size="mini"
                />
              </el-form-item>
              <el-form-item label="所在地址：" prop="address">
                <div style="display: flex;cursor: pointer;align-items: center;" @click="mapVisible=true">
                  <el-input
                    :disabled="true"
                    style="width:90%;margin-right: 10px;"
                    v-model="companyData.address"
                    placeholder="点击选择仓库地址"
                    autocomplete="off"
                    size="small"
                  />
                  <i class="el-icon-location"/>
                </div>
              </el-form-item>
              <span v-if="companyData.area" style="color: #606266;font-weight:700;margin-left: 25px;font-size: 14px;">所在区域：<span>{{companyData.area}}</span></span>
              <el-form-item label="车位类型：" prop="type">
                <el-radio v-model="companyData.type" :label="2">车位</el-radio>
                <el-radio v-model="companyData.type" :label="1">车道</el-radio>
              </el-form-item>
              <el-form-item label="免费停放：" prop="free">
                <div class="unitContainer">
                  <el-input
                    :style="'width:150px'"
                    v-model="companyData.free"
                    autocomplete="off"
                    placeholder="请输入停放数量"
                    size="mini"
                  />
                  <el-select v-model="companyData.unit" filterable size="mini" style="width:60px;margin-left: 10px;">
                    <el-option v-for="item in unitOption" :key="item.label" :label="item.label" :value="item.value"/>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="收费单价：" prop="price" style="margin-bottom: 20px;">
                <div class="unitContainer2">
                  <el-input
                    style="width:150px;margin-right: 10px;"
                    v-model="companyData.price"
                    placeholder="请输入超时金额"
                    autocomplete="off"
                    size="mini"
                  >
                    <span slot="suffix" style="color: #999">元</span>
                  </el-input>
                  <el-select v-model="companyData.unit2" filterable size="mini" style="width:60px">
                    <el-option v-for="item in unitOption" :key="item.label" :label="item.label" :value="item.value"/>
                  </el-select>
                </div>
              </el-form-item>
            </div-border>
            <div class="btnContainer">
              <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick">确认</el-button>
              <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
            </div>
          </el-form>
        </div>
      </popup>
    </transition>
    <transition name="el-fade-in-linear">
      <popup width="850" title="详细地址" :show.sync="mapVisible" center>
        <web-map :useType="'select'" @close="mapClose" v-if="mapVisible" :address="companyData.address"/>
      </popup>
    </transition>>
  </div>
</template>

<script>
import webMap from '@/components/map'
import popup from "@/components/popup";
import {formatDateTime, getSessionStore, removeSpace} from "@/config/mUtils";
import divBorder from "@/components/divBorder";
import {
  storehouseList,
  storehouseIsEnable,
  storehouseDetail,
  addStorehouse,
  updateStorehouse,
} from "@/service/basicfile"

export default {
  components: {
    divBorder,
    webMap,
    popup,
  },
  data() {
    return {
      nameIpt:'',
      areaIpt:'',
      stateIpt:'',
      typeIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'启用中'},
        {value:0,label:'禁用中'},
      ],
      typeOption:[
        {value:'',label:'全部',},
        {value:1,label:'车道'},
        {value:0,label:'车位'},
      ],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{},
      operationData:[],
      dialogTitle:'',
      dialogVisible:false,
      addLoad:false,
      companyData:{
        warehouse:'',
        address:'',
        free:'',
        unit:0,
        price:'',
        unit2:0,
      },
      unitOption:[
        {value:1,label:'天'},
        {value:2,label:'时'},
      ],
      rules:{
        warehouse:[
          { required: true, message: '请输入仓库名字', trigger: 'blur' },
        ],
        address:[
            { required: true, message: '请选择所在地址', trigger: 'change' },
        ],
        free:[
            { required: true, message: '请选择免费停放时间', trigger: 'change' },
        ],
        type:[
            { required: true, message: '请选择车位类型', trigger: 'change' },
        ],
        price:[
            { required: true, message: '请选择超时收费标准', trigger: 'change' },
        ],
      },
      regionList: [],
      mapVisible:false,
    };
  },
  mounted() {
    this._storehouseList();
    this.regionList = JSON.parse(getSessionStore("areaList"));
  },
  computed:{
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
    getStyle() {
      return (val) => {
        switch (val) {
          case 1:
            return 'color: #3388ff'
          case 0:
            return 'color:#F56C6C;'
        }
      }
    },
    getState(){
      return function(state){
        switch(state) {
          case 1:
            return '启用中'
          case 0:
            return '禁用中'
        }
      };
    },
    getLocationType(){
      return function(type){
        switch(type) {
          case 1:
            return '车道'
          case 2:
            return '车位'
          default:
            return '-'
        }
      };
    },
    getFreeNumber(){
      return function(type){
        switch(type) {
          case 1:
            return '天'
          case 2:
            return '时'
        }
      };
    },
  },
  methods: {
    mapClose(val, lnglat,area){
      this.companyData.address=val;
      this.companyData.longitude=lnglat[0];
      this.companyData.dimension=lnglat[0];
      this.companyData.area=area;
      this.mapVisible=false;
    },
    async _storehouseList(){
      this.tableLoad=true;
      let str='';
      if(this.areaIpt)
      this.areaIpt.forEach((item,index)=>{
        if(index!==this.areaIpt.length-1) str+=item+',';
        else str+=item;
      })
      const obj={
        storehouseName:this.nameIpt,
        regionId:str,
        status:this.stateIpt,
        locationType:this.typeIpt,
        rows:this.size,
        page:this.page,
      };
      const res = await storehouseList(obj);
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._storehouseList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._storehouseList();
    },
    disableClick(id){
      this.$confirm('确定要禁用当前仓库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await storehouseIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._storehouseList();
      }).catch(() => {});
    },
    async detailClick(id) {
      const res = await storehouseDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData=res.data;
      this.operationData=res.data.operateRecordList;
      this.detailDialogVisible = true;
    },
    changeClick(item){
      this.companyData={
        ...item,
        warehouse:item.storehouseName,
        address:item.address,
        area:item.regionName,
        free:item.freeNumber,
        unit:item.freeType,
        price:item.payMoney,
        unit2:item.payType,
        type:item.locationType,
      };
      this.dialogTitle='修改仓库';
      this.dialogVisible=true;
    },
    searchBtn(){
      this.page = 1;
      this._storehouseList();
    },
    resetBtn(){
      this.nameIpt='';
      this.areaIpt='';
      this.stateIpt='';
      this.typeIpt='';
    },
    addBtn(){
      this.dialogTitle='添加仓库';
      this.dialogVisible=true;
      this.companyData={
        warehouse:'',
        address:'',
        free:'',
        unit:1,
        price:'',
        unit2:1,
        area:'',
      };
    },
    addClick(){
      this.companyData=removeSpace(this.companyData);
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let id='';
          let arr = this.companyData.area.split('-');
          if(arr[arr.length-1] === '钓鱼岛') id=this.regionList[this.regionList.length-1].id;
          else
          for(let i=0;i<this.regionList.length;i++) {
            for(let j=0;j<this.regionList[i].children.length;j++) {
              for(let k=0;k<this.regionList[i].children[j].children.length;k++) {
                if(this.regionList[i].children[j].children[k].cityName === arr[arr.length-1]){
                  id=this.regionList[i].children[j].children[k].id;
                  break;
                }
              }
            }
          }
          let str ='';
          arr.forEach(item=>{str+=item});
          this.addLoad = true;
          const obj ={
            id:this.companyData.id,
            storehouseName:this.companyData.warehouse,
            address:this.companyData.address,
            longitude:this.companyData.longitude,
            dimension:this.companyData.dimension,
            regionId:this.dialogTitle==='添加仓库'?id:this.companyData.regionId,
            regionName:str,
            locationType:this.companyData.type,
            freeNumber:Number(this.companyData.free),
            freeType:this.companyData.unit,
            payType:this.companyData.unit2,
            payMoney:Number(this.companyData.price),
          };
          const res = this.dialogTitle==='添加仓库'?await addStorehouse(obj):await updateStorehouse(obj);
          this.addLoad = false;
          if(res.status !== 0) return this.$message.error(res.message);
          else this.$message.success(res.message);
          await this._storehouseList();
          this.dialogVisible=false;
        } else {
          return false;
        }
      });
    },
    enableClick(id){
      this.$confirm('确定要启用当前仓库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await storehouseIsEnable(id);
        if(res.status !== 0) return this.$message.error(res.message);
        else this.$message.success(res.message);
        await this._storehouseList();
      }).catch(() => {});
    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
        .el-loading-mask{
          z-index: 1020;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    .unitContainer{
      display: flex;
      align-items:center;
      //justify-content:space-between;
      //width:140px;
      margin-bottom:5px;
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    .unitContainer2{
      display: flex;
      align-items:center;
      //justify-content:space-between;
      //width:189px;
      margin-bottom:5px;
      span{
        color: #606266;
        font-weight: 700;
      }
      ::v-deep{
        .el-input__inner{
          border: 1px solid #DCDFE6;
        }
      }
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
      .el-form-item{
        margin-bottom:13px;
      }
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
